import { render, staticRenderFns } from "./currencySettings.vue?vue&type=template&id=63e066ac&scoped=true"
import script from "./currencySettings.vue?vue&type=script&lang=js"
export * from "./currencySettings.vue?vue&type=script&lang=js"
import style0 from "./currencySettings.vue?vue&type=style&index=0&id=63e066ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e066ac",
  null
  
)

export default component.exports